module.exports = __webpack_public_path__ + "static/media/superman.896a5b69.jpg";